import { FixedInvestActions } from './fixedInvest.action';
import { UtilitiesService } from '../../services/utilities.service';
import { InitializerAction } from '../initializer/initiliazer.action';
import { PortfolioType } from '../../models/fixedincome/portfolio.model';
import { persistReducer } from '../indexeddb/store-persist/store-persist';
import { IStrategicalClassesIndexers } from '../../interfaces/fixedincome/strategical-classes-indexers.interface';
import { IFgcOvertakenIssuers } from '../../interfaces/fixedincome/fgc-overtaken.interface';
import { ITreasuryPositionsResponse } from '../../interfaces/fixedincome/treasury-positions-response.interface';

export class FixedInvestState {
    public products: Array<any>;
    public productsByIndex: any;
    public advice: Array<any>;
    public product: any;
    public issuer: any;
    public pending: boolean;
    public pendingMyInvestments: boolean;
    public error: null;
    public selectedProduct: PortfolioType;
    public investments: any[];
    public simulation: any[];
    public valuesSimulation: any;
    public myInvestments: IStrategicalClassesIndexers;
    public treasuryInvestments: ITreasuryPositionsResponse;
    public fgcOvertaken: {
        accepted: Array<number>,
        issuers: IFgcOvertakenIssuers[],
        error: boolean
    };
}

export const initialGenericState: FixedInvestState = {
    advice: [],
    products: null,
    productsByIndex: null,
    product: '',
    issuer: '',
    pending: false,
    pendingMyInvestments: false,
    error: null,
    simulation: [],
    selectedProduct: new PortfolioType(),
    investments: [],
    valuesSimulation: null,
    myInvestments: {
        posfixed: [],
        linkedToInflation: [],
        prefixed: [],
        none: [],
    },
    treasuryInvestments: null,
    fgcOvertaken: {
        accepted: [],
        issuers: null,
        error: false
    },
};

export function FixedInvestReducer(state: FixedInvestState, action: FixedInvestActions) {
    return fixedInvestReducer(state, action);
}

const fixedInvestReducer = persistReducer<FixedInvestState, FixedInvestActions>({
    name: 'fixedInvest',
    initialState: initialGenericState,
    reducer: (state, action) => {

        switch (action.type) {
            case FixedInvestActions.getProducts:
                return {
                    ...state,
                    ...{ pending: true, error: null },
                };
            case FixedInvestActions.getProductsSuccess:
                return {
                    ...state,
                    ...{ pending: false, error: null, products: action.payload },
                };
            case FixedInvestActions.getProductsError:
                return {
                    ...state,
                    ...{ pending: false, error: action.payload },
                };

            case FixedInvestActions.getProductsIndexBydate:
                return {
                    ...state,
                    ...{ pending: true, error: null },
                };
            case FixedInvestActions.getProductsIndexBydateSuccess:
                return {
                    ...state,
                    ...{
                        pending: false,
                        error: null,
                        productsByIndex: UtilitiesService.mergeIndexableObject(state.productsByIndex, [action.payload], 'time'),
                    },
                };
            case FixedInvestActions.getProductsIndexBydateError:
                return {
                    ...state,
                    ...{ pending: false, error: action.payload },
                };

            case FixedInvestActions.setSelectedProduct:
                return {
                    ...state,
                    selectedProduct: action.payload,
                    valuesSimulation: !!action && !!action.values ? action.values : null,
                };

            case FixedInvestActions.getProduct:
                return {
                    ...state,
                    ...{ pending: true, error: null },
                };
            case FixedInvestActions.getProductSuccess:
                return {
                    ...state,
                    ...{ pending: false, error: null, product: action.payload },
                };
            case FixedInvestActions.getProductError:
                return {
                    ...state,
                    ...{ pending: false, error: action.payload },
                };

            case FixedInvestActions.getIssuer:
                return {
                    ...state,
                    ...{ pending: true, error: null },
                };
            case FixedInvestActions.getIssuerSuccess:
                return {
                    ...state,
                    ...{ pending: false, error: null, issuer: action.payload },
                };
            case FixedInvestActions.getIssuerError:
                return { ...state, ...{ pending: false, error: action.payload } };

            //@deprecated [init] - remover ate 01/01/2024
            case FixedInvestActions.getMyInvestments:
                return {
                    ...state,
                    ...{ pendingMyInvestments: true, pending: true, error: null },
                };
            case FixedInvestActions.getMyInvestmentsSuccess:
                const {
                    posfixed: _posfixed,
                    linkedToInflation: _linkedToInflation,
                    prefixed: _prefixed,
                    none: _none,
                } = action.payload;
                return {
                    ...state,
                    ...{
                        pendingMyInvestments: false,
                        pending: false,
                        error: null,
                        myInvestments: {
                            posfixed: _posfixed,
                            linkedToInflation: _linkedToInflation,
                            prefixed: _prefixed,
                            none: _none,
                        },
                    },
                };
            case FixedInvestActions.getMyInvestmentsError:
                return {
                    ...state,
                    ...{ pendingMyInvestments: false, pending: false, error: action.payload },
                };
            //@deprecated [end] - remover ate 01/01/2024

            case FixedInvestActions.getPositions:
                return {
                    ...state,
                    ...{ pendingMyInvestments: true, pending: true, error: null },
                };

            case FixedInvestActions.getPositionsSuccess:
                const { posfixed, linkedToInflation, prefixed, none } = action.payload;
                return {
                    ...state,
                    ...{
                        pendingMyInvestments: false,
                        pending: false,
                        error: null,
                        myInvestments: { posfixed, linkedToInflation, prefixed, none },
                    },
                };

            case FixedInvestActions.getPositionsError:
                return {
                    ...state,
                    ...{ pendingMyInvestments: false, pending: false, error: action.payload },
                };

            case FixedInvestActions.getPositionsSegregated:
                return {
                    ...state,
                    ...{ pendingMyInvestments: true, pending: true, error: null },
                };

            case FixedInvestActions.getPositionsSegregatedSuccess:
                return {
                    ...state,
                    ...{
                        pendingMyInvestments: false,
                        pending: false,
                        error: null,
                        treasuryInvestments: action.payload,
                    },
                };

            case FixedInvestActions.getPositionsSegregatedError:
                return {
                    ...state,
                    ...{ pendingMyInvestments: false, pending: false, error: action.payload },
                };

            case FixedInvestActions.updateSimulation:
                return { ...state, simulation: action.payload };
            case FixedInvestActions.computeSimulation:
                return {
                    ...state,
                    ...{ pending: true, error: null },
                };
            case FixedInvestActions.computeSimulationSuccess:
                return {
                    ...state,
                    ...{ pending: false, error: null, simulation: action.payload },
                };

            case FixedInvestActions.buyProduct:
                return {
                    ...state,
                    ...{ pending: true },
                };
            case FixedInvestActions.buyProductSuccess:
                return {
                    ...state,
                    ...{ pending: false, error: null },
                };
            case FixedInvestActions.buyProductError:
                return {
                    ...state,
                    ...{ pending: false, error: action.payload },
                };

            case FixedInvestActions.getAdvices:
                return {
                    ...state,
                    ...{ pending: true, error: null },
                };
            case FixedInvestActions.getAdvicesSuccess:
                return {
                    ...state,
                    ...{ pending: false, error: null, advice: [...action.payload] },
                };
            case FixedInvestActions.getAdvicesError:
                return { ...state, ...{ pending: false, error: action.payload } };

            case InitializerAction.resetUserRelatedData:
                return {
                    ...state,
                    ...{
                        myInvestments: initialGenericState.myInvestments,
                        treasuryInvestments: initialGenericState.treasuryInvestments,
                        advice: initialGenericState.advice,
                    },
                };

            case FixedInvestActions.setIssuersFgcOvertaken:
                return {
                    ...state,
                    ...{
                        fgcOvertaken: {
                            ...state.fgcOvertaken,
                            issuers: [...action.payload],
                        },
                    },
                };

            case FixedInvestActions.findAcceptedFgcOvertakenSuccess:
                return {
                    ...state,
                    ...{
                        fgcOvertaken: {
                            ...state.fgcOvertaken,
                            accepted: [...action.payload],
                            error: false,
                        },
                    },
                };

            case FixedInvestActions.findAcceptedFgcOvertakenError:
                return {
                    ...state,
                    ...{
                        fgcOvertaken: {
                            ...state.fgcOvertaken,
                            error: true
                        },
                    },
                };

            default:
                return state;
        }

    },
});
